import { render, staticRenderFns } from "./EditGenericName.vue?vue&type=template&id=d1c662e8&scoped=true"
import script from "./EditGenericName.vue?vue&type=script&lang=js"
export * from "./EditGenericName.vue?vue&type=script&lang=js"
import style0 from "./EditGenericName.vue?vue&type=style&index=0&id=d1c662e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c662e8",
  null
  
)

export default component.exports